import axios from "@/libs/api.request";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/common/clientDestroyDay",
    params,
    method: "get"
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/common/clientDestroyDay",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = id => {
  return axios.request({
    url: `/common/clientDestroyDay/${id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/common/clientDestroyDay/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = data => {
  return axios.request({
    url: `/common/clientDestroyDay/${data.id}`,
    method: "DELETE"
  });
};